import { get, post, put, destroy } from '@/api/request';

function fetchCompanies(params) {
  return get('/companies', params);
}

function fetchSingleCompany({ id }) {
  return get(`/companies/${id}`);
}

function createCompany(data) {
  return post('/companies', data);
}

function updateCompany({ id, data }) {
  return put(`/companies/${id}`, data);
}

function deleteCompany(id) {
  return destroy(`/companies/${id}`);
}

export default {
  fetchCompanies,
  fetchSingleCompany,
  createCompany,
  updateCompany,
  deleteCompany,
};



// WEBPACK FOOTER //
// ./src/store/modules/company/api.js